import { createContext } from 'react'

type ListContextType = {
  dense: boolean
  disableGutters: boolean
}

const ListContext = createContext<ListContextType>({
  dense: false,
  disableGutters: false,
})

export default ListContext
